'use client';
import { useState } from 'react';
import SMSForm from '../../Footer/comp/SMSForm';
import EmailForm from '../../Footer/comp/EmailForm';
import getLocal from '@/app/utils/getLocal';

export default function FooterEmailA({ theme = '', needEmailAgree }: { theme: string; needEmailAgree?: boolean }) {
    const { locale = 'us' } = getLocal();
    const [emailSubscription, setEmailSubscription] = useState('');
    const [smsSuccess, setSmsSuccess] = useState('');

    return (
        <>
            {emailSubscription && !smsSuccess ? (
                <SMSForm locale={locale} email={emailSubscription} theme={theme} setSmsSuccess={setSmsSuccess} />
            ) : (
                <EmailForm
                    locale={locale}
                    needEmailAgree={needEmailAgree}
                    setEmailSubscription={setEmailSubscription}
                    smsSuccess={smsSuccess}
                    setSmsSuccess={setSmsSuccess}
                />
            )}
        </>
    );
}
